module.exports = __webpack_public_path__ + "static/media/india-country.203176ae.svg";